import type { Theme } from "@mui/material";
import { createTheme, darken, ThemeProvider } from "@mui/material";
import type { ReactNode } from "react";
import { useCallback } from "react";
import { lightThemeOptions } from "@entrilia/shared/theme";
import useClientContext from "../contexts/useClientContext";

const CustomThemeProvider = (props: { children?: ReactNode | undefined }) => {
  const { portalSettings } = useClientContext();

  const applyFavicon = useCallback((url: string | undefined) => {
    const favicon = document.head.querySelector<HTMLLinkElement>("link[rel=icon]");
    if (favicon) {
      favicon.href = url || "/favicon.ico";
    }
  }, []);

  const applyThemeCustomization = useCallback(
    (outerTheme: Theme) => {
      if (!portalSettings) {
        return outerTheme;
      }

      const theme = createTheme(lightThemeOptions);

      if (portalSettings.mainColor) {
        theme.palette.primary.main = portalSettings.mainColor;
        theme.palette.primary.dark = darken(portalSettings.mainColor, 0.2);
      }

      applyFavicon(portalSettings.faviconUrl);

      return theme;
    },
    [portalSettings, applyFavicon]
  );

  return (
    <ThemeProvider<Theme> theme={(outerTheme) => applyThemeCustomization(outerTheme)}>{props.children}</ThemeProvider>
  );
};

export default CustomThemeProvider;
